import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CalculationReturnOfInvestmentsService } from '@/infra/services/calculation-return-of-investments';

interface CreateCalculationReturnOfInvestmentsParams {
	email: string;
	phone: string;
	position: string;
	full_name: string;
	company_name: string;
}

const Service = CalculationReturnOfInvestmentsService.getInstance();

export const useCreateCalculationReturnOfInvestments = () => {
	return useMutation({
		mutationFn: async (params: CreateCalculationReturnOfInvestmentsParams) => Service.create(params),
		onError: () => {
			message.error(I18n.get('Failed to create return of investments'));
		}
	});
};
